import { IconCopy as Copy } from "@tabler/icons-react";
import { useState } from "react";
import { copyText } from "./clipboardCopy";

interface SessionIdentityProps {
  agentSessionId: string | null;
  compact?: boolean;
  className?: string;
}

export function SessionIdentity({
  agentSessionId,
  compact = false,
  className = "",
}: SessionIdentityProps) {
  const [feedback, setFeedback] = useState("");

  const copy = async () => {
    if (!agentSessionId) return;
    const result = await copyText(agentSessionId);
    setFeedback(result.ok ? "Session ID 已复制" : "复制失败，请选中后手动复制");
  };

  return (
    <div
      className={`session-identity ${compact ? "session-identity--compact" : ""} ${className}`.trim()}
    >
      {!compact ? (
        <span>
          Session ID
          <code title={agentSessionId ?? undefined}>{agentSessionId ?? "首次发送后生成"}</code>
        </span>
      ) : null}
      <button
        type="button"
        aria-label="复制 Session ID"
        title={agentSessionId ? "复制 Session ID" : "首次发送后生成 Session ID"}
        disabled={!agentSessionId}
        onClick={() => void copy()}
      >
        <Copy size={14} aria-hidden="true" />
      </button>
      {feedback ? (
        <small
          className={compact ? "sr-only" : undefined}
          role={feedback.startsWith("复制失败") ? "alert" : "status"}
        >
          {feedback}
        </small>
      ) : null}
    </div>
  );
}
